import { ErrorMessageConfig, HttpErrorMessageConfig, ErrorStatusMessageConfig } from '@paysera/error-message-resolver';

const getErrorMessageConfig = (errorMessage) => {
    const httpConfig = new HttpErrorMessageConfig(errorMessage)
        .setStatus(
            new ErrorStatusMessageConfig().setConfig({
                500: errorMessage,
            }),
        )

    
    return new ErrorMessageConfig(httpConfig, errorMessage);
};

export default getErrorMessageConfig;
